export default __webpack_public_path__ + "static/media/calibri-regular.40a989a6.woff";